export const MuiButtonStyle = {
    loadingButton:{
        display: "flex",
        fontSize:"14px",
        background: "linear-gradient(to right,#F03750, #E72D7E)",
        boxShadow: "none",
        color: "#FFFFFF",
        "&:hover": {
          background: "linear-gradient(to right,#F03750, #E72D7E)",
        },
        ".MuiLoadingButton-loadingIndicator":{
               color:"white",
               size:20,
        }
    },
    button:{
        display: "flex",
        background: "linear-gradient(to right,#F03750, #E72D7E)",
        boxShadow: "none",
        color: "#FFFFFF",
        "&:hover": {
          background: "linear-gradient(to right,#f22943, #ed2179)",
        }
    }, 
    grayColorButton:{
      background: "#EEEEEE",
        boxShadow: "none",
        color: "#000000",
        border:"1px solid #000000",
        "&:hover": {
          background: "#000000",
          color:"#EEEEEE"
        }
    },
    lightButtonWithColorHover:{
      background: "#fff",
      boxShadow: "none",
      color: "#000000",
      border:"1px solid #000000",
      "&:hover": {
        background: "linear-gradient(to right,#F03750, #E72D7E)",
        color:"#FFFFFF",
        border:"1px solid #FFFFFF",
      }
    },
    lightButtonWithoutHover:{
      background: "#fff",
      boxShadow: "none",
      color: "#000000",
      border:"1px solid #000000",
      "&:hover": {
        background: "#fff",
        color: "#000000",
      }
    },   
    lightButtonColor:{
      background: "#fff",
      boxShadow: "none",
      color: "#000000",
      border:"1px solid #000000",
      "&:hover": {
        background: "#EEEEEE",
        color: "#000000",
      }
    },   
    lightButton:{
      background: "#707070",
        boxShadow: "none",
        color: "#FFFFFF",
        "&:hover": {
          background: "#5b5a5a",
        }
    },
    whiteToBlack:{
        background: "#fff",
        boxShadow: "none",
        border:'1px solid #262626',
        color: "#262626",
          "&:hover": {
            background: "#262626",
            color:'#fff',
            boxShadow: "none",
            border:'1px solid #262626',
          }
    } ,
    darkToDarker:{
      background: "rgb(0,0,0,0.7)",
      boxShadow: "none",
      borderRadius: "4px",
      color: "#d8d8d8",
      "&:hover": {
        background: "#262626",
        color:'#fff',
        boxShadow: "none",
      },
      "&:active": {
        background: "#262626",
        color:'#fff',
        boxShadow: "none",
      },
    },
};